/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
export const jfpPerfFeatureFlags = [] as const;
